import React from "react";
import classNames from "classnames";

type LoaderProps = {
    loading?: boolean;
    fullscreen?: boolean; // include the container/overlay
    top?: boolean; // z-index to the top (over modals)
};

const Loader = ({ loading = true, fullscreen = true, top = true }: LoaderProps) => {
    if (!loading) {
        return null;
    }

    const loader = <div className="loader2" />;

    if (!fullscreen) {
        return loader;
    }

    return (
        <div
            className={classNames("loader2-container", {
                "loader2-container-top": top,
            })}
        >
            {loader}
        </div>
    );
};

export const CenteredLoader = ({
    loading = true,
    top = true,
}: {
    loading?: boolean;
    top?: boolean;
}) => (
    <div className="w-100 h-100 flex flex-col">
        <div className="prel flex flex-col flex-ac flex-jc flex-grow">
            <Loader loading={loading} fullscreen={false} top={top} />
        </div>
    </div>
);

export default Loader;
